export default "__VITE_ASSET__5977604b__"